import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Insurer, Owner } from 'app/types';
import insurerService from 'app/Domain/Insurers/Services/InsurerService/insurerService';
import { OWNER_INSURERS_QUERY_KEY } from './useOwnerInsurerQuery';

type EditInsurerOwnerArgs = {
  ownerId: Owner['ownerId'];
  insurerId: Insurer['insurerId'];
  values: Record<string, any>;
};

export const useEditInsurerOwnerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, EditInsurerOwnerArgs>(
    ({ ownerId, insurerId, values }) => insurerService.editInsurerOwner(ownerId, insurerId, values),
    {
      onSuccess: (_, { ownerId }) => {
        queryClient.invalidateQueries([OWNER_INSURERS_QUERY_KEY, ownerId]);
      },
    },
  );
};
